import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Pattern } from 'src/app/interfaces/pattern';
import { Element } from 'src/app/interfaces/element';
import { Product } from 'src/app/interfaces/product';
import { FirestoreService } from 'src/app/services/firestore.service';
import { FilterService } from 'src/app/services/filter.service';
import { DocumentSnapshot, QuerySnapshot } from '@angular/fire/firestore';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  tagSearchTerm?: string;

  filters = [
    {
      colUid: 'products',
      label: 'products',
      docs: <Product[]>[],
    },
    {
      colUid: 'patterns',
      label: 'patterns',
      docs: <Pattern[]>[],
    },
    {
      colUid: 'elements',
      label: 'elements',
      docs: <Element[]>[],
    },
  ];

  constructor(
    private firestore: FirestoreService,
    private route: ActivatedRoute,
    public filterService: FilterService,
    public sharedService: SharedService
  ) {}

  ngOnInit(): void {
    // get filter arrays
    this.filters.forEach((filter) => {
      this.setFilterArray(filter.colUid);
    });
    this.subscribeToRoute();
  }

  // set filters based on route params
  private subscribeToRoute(): void {
    this.route.queryParams.subscribe((queryParams: ParamMap) => {
      this.filters.forEach((filter) => {
        const filterValue = queryParams[filter.colUid];
        if (typeof filterValue === 'object') {
          this.filterService.filters[filter.colUid] = filterValue;
        } else if (typeof filterValue === 'string') {
          this.filterService.filters[filter.colUid] = [filterValue];
        }
      });
      // reset pages array and last page before getting new ones
      this.filterService.pages = [];
      this.filterService.lastPageSnapshot = undefined;
      this.filterService.getPages();
    });
  }

  // get filter documents and push to array
  private setFilterArray(colUid: string): void {
    this.firestore
      .getCollection(colUid)
      .then((querySnapshot: QuerySnapshot<Product | Pattern | Element>) => {
        querySnapshot.docs.forEach((docSnapshot: DocumentSnapshot<any>) => {
          const filterObject = this.filters.find(
            (filter) => filter.colUid === colUid
          );
          filterObject.docs.push(docSnapshot.data());
        });
      });
  }

  // check if list of keywords contains search term
  containsSearchTerm(keywords: string[]): string {
    return keywords?.find((a) => a.includes(this.tagSearchTerm));
  }
}
